export default {"src":"/_next/static/media/logo.68417d3c.svg","height":64,"width":316,"blurWidth":0,"blurHeight":0};